const C = require("../constants");
const initial_data = {
    open: false,
    ticket: {
        id: null,
        sale: {
            client: null,
            state: null
        },
        ticket: {
            has_expiration: false
        },
        is_active: false
    }
};

function TicketEditReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TICKET_EDIT_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default TicketEditReducer;


// WEBPACK FOOTER //
// ./src/reducers/TicketEditDialogReducer.js